const infodata = [
    { 
        id: 'info-1',
        banner : process.env.PUBLIC_URL+'/lika_img/info-banner_1.jpg',
        title: '레스케이프 호텔 협업',
        detail: process.env.PUBLIC_URL+'/lika_img/info-detail_1.jpg',
        text: '레스케이프 호텔과 콜라보레이션을 진행하였습니다 레스케이프 호텔의 모든 펫 객실에서 리카리카의 커브형 논슬립 계단과 릴렉싱 더블 방석’을 체험해 보실 수 있습니다. 7층 로비 라운지에서는 리카리카의 코튼 캔디 산책용품 세트와 곰돌이 베베 산책용품 세트를 구매하실 수 있습니다.'
    },
    { 
        id: 'info-2',
        banner : process.env.PUBLIC_URL+'/lika_img/info-banner_2.jpg',
        title: '23 더현대서울 팝업스토어 진행',
        detail: process.env.PUBLIC_URL+'/lika_img/info-detail_2.jpg',
        text: '리카리카 더현대 팝업스토어 진행'
    },
]
export default infodata